export const track = (event, params = {}) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", event, { page_path: window.location.pathname, ...params });
  }
};

const HREF_EVENTS = [
  ["tel:", "call_click"],
  ["sms:", "text_click"],
  ["wa.me", "whatsapp_click"],
  ["paypal.com/businessoperator/booking", "book_click"],
];

let initialized = false;

export const initClickTracking = () => {
  if (initialized || typeof document === "undefined") return;
  initialized = true;
  document.addEventListener(
    "click",
    (e) => {
      const a = e.target.closest && e.target.closest("a[href]");
      if (!a) return;
      const href = a.getAttribute("href") || "";
      for (const [needle, event] of HREF_EVENTS) {
        if (href.includes(needle)) {
          track(event, { link_url: href, link_text: (a.textContent || "").trim().slice(0, 60) });
          return;
        }
      }
    },
    true
  );
};
